import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useStyles } from './styles';

interface Props {
  title: string;
}
export const PageTitle: FC<Props> = ({ title }) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.root}>
      {title}
    </Grid>
  );
};
